var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00063 10.1699L2.53063 6.69995C2.14063 6.30995 1.51063 6.30995 1.12062 6.69995C0.730625 7.08995 0.730625 7.71995 1.12062 8.10995L5.30063 12.2899C5.69063 12.6799 6.32063 12.6799 6.71063 12.2899L17.2906 1.70995C17.6806 1.31995 17.6806 0.689946 17.2906 0.299946C16.9006 -0.0900537 16.2706 -0.0900537 15.8806 0.299946L6.00063 10.1699Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.2443238f7af38b8a075631aee39416fd.svg";
export { ForwardRef as ReactComponent };